import bilAPI from "../api";

export const getTopics = ({ params: { grade, subject, search, page, page_size }, signal }) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/questions/topics/`, { params: { grade, subject, search, page, page_size }, signal })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("axios error");
        });
    } catch (error) {
      reject("system error");
    }
  });
};
